import { render, staticRenderFns } from "./GenericInfoCard.vue?vue&type=template&id=fa322e70&scoped=true&"
import script from "./GenericInfoCard.vue?vue&type=script&lang=js&"
export * from "./GenericInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./GenericInfoCard.vue?vue&type=style&index=0&id=fa322e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa322e70",
  null
  
)

export default component.exports